import React from 'react';
import Layout from '../components/Layout';
import DividendCalendar from '../components/DividendCalendar';

const Calendar: React.FC = () => {
  return (
    <Layout>
      <DividendCalendar />
    </Layout>
  );
};

export default Calendar;
